<template>
  <div>
   
    <autoLogout />
    <loader :loader="sending" />

    <div class="wrapper-content">
      <encabezado :elementos="encabezado" v-if="showAction(1)"/>
      <v-card v-if="showAction(1)">
        <v-card-text>
          <v-row align="baseline" justify="center" class="pb-4">
            <branch-offices-list
              :classOfDiv="cols"
              style="padding-top: 22px"
              v-on:triggerChange="branchOfficeSelected"
              :model="idBranchOfficeSelected"
            />
            <v-col>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              v-if="$utilFront.withPermission($prm.STOCK_MINUS)"
              cols="12"
              md="4"
              sm="12"
              xl="3"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    block
                    @click="changeAction(2)"
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left> mdi-archive-minus </v-icon> Nueva salida
                  </v-btn>
                </template>
                <span>Registrar salida de medicamento</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="list"
            :search="search"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              'items-per-page-all-text': 'Todo',
            }"
            no-results-text="Sin resultados coincidentes con el búsqueda"
            loading-text="Cargando..."
            no-data-text="Sin resultados disponibles"
            dense
            fixed-header
            height="auto"
          >
            <template v-slot:[`item.product.text`]="{ item }">
              <small>{{ item.product.text }}</small>
            </template>

            <template v-slot:[`item.actions`]="{ item, index }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="get(item, index)">
                    <v-icon color="blue" v-bind="attrs" v-on="on">
                      mdi-information-variant
                    </v-icon>
                  </v-btn>
                </template>
                <span>Ver información</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-text>
          <v-row align="baseline" justify="center" class="pb-4">
            <v-col class="text-center">
             
                  <v-btn
                    @click="dialog = true"
                    outlined
                    small
                    color="error"
                  >
                    <v-icon left> mdi-file-pdf-box </v-icon> Reporte Salida
                  </v-btn>
                
            </v-col>
            <!-- <v-col>
              <v-btn
                outlined
                small
                color="green darken-1"
                :disabled="sending"
                @click="downloadReportXLSX()"
                >Exportar excel
                <v-icon right>mdi-microsoft-excel</v-icon>
              </v-btn>
            </v-col> -->
          </v-row>
        </v-card-text>
      </v-card>
      <encabezado :elementos="encabezado" v-if="showAction(2)"/>
      <v-card v-if="showAction(2)">
        <validation-observer ref="observer" v-slot="{ invalid }">
          <v-form @submit.prevent="doAction">
            <v-card-text>
              <v-row>
                <v-col>
                  <h3 class="font-weight-black">Información de merma</h3>
                </v-col>
              </v-row>
              <v-row align="center" justify="center">
                <v-col cols="12" md="6" sm="12">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Motivo"
                    rules="max:355|required"
                  >
                    <v-textarea
                      rows="1"
                      auto-grow
                      v-model="model.comment"
                      :counter="355"
                      :maxlength="355"
                      required
                      name="Motivo"
                      :error-messages="errors"
                      clearable
                      label="Motivo"
                    />
                  </validation-provider>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <h3 class="font-weight-black">Productos en almacén</h3>
                </v-col>
              </v-row>

              <v-row>
                <v-col md="12" sm="12" lg="12">
                  <h4 :class="selected == 0 ? 'error--text' : 'success-text'">
                    Seleccionados: <span>{{ selected }}</span>
                  </h4>
                  </v-col>
                  <v-col md="1" sm="1" lg="1">
                  <v-switch
                    :disabled="sending"
                    label="Todo"
                    v-model="all"
                    @click="selectedAll()"
                    hide-details
                  ></v-switch>
                </v-col>
              </v-row>

              <v-row align="center" justify="center" class="pb-4">
                <v-col>
                  <v-text-field
                    v-model="searchStock"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-data-table
                :headers="headersStock"
                :items="stocks"
                :search="searchStock"
                :items-per-page="5"
                :footer-props="{
                  'items-per-page-text': 'Elementos por página',
                  'items-per-page-all-text': 'Todo',
                }"
                no-results-text="Sin resultados coincidentes con el búsqueda"
                loading-text="Cargando..."
                no-data-text="Sin resultados disponibles"
                dense
                fixed-header
                height="auto"
              >
                <template v-slot:[`item.product.fullName`]="{ item }">
                  <small>{{ item.product.fullName }}</small>
                </template>

                <template v-slot:[`item.quantityOutput`]="{ item, index }">
                  <validation-provider
                    v-if="item.unsubscribe"
                    v-slot="{ errors }"
                    name=" "
                    :key="index"
                    :rules="`min_value:1|numeric|max_value:${item.quantity}|required`"
                  >
                    <v-text-field
                      :disabled="sending || !item.unsubscribe"
                      v-model="item.quantityOutput"
                      @change="outRangeStocks()"
                      :error-messages="errors"
                      type="number"
                      :key="index"
                      min="1"
                      required
                      :max="item.quantity"
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                  <span v-else>- -</span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <div class="d-flex justify-center">
                    <v-checkbox
                      hide-details
                      v-model="item.unsubscribe"
                      @click="updateAll()"
                    />
                  </div>
                </template>
              </v-data-table>
            </v-card-text>

            <v-card-actions>
              <v-row align="center" justify="center" class="text-center py-4">
                <v-col>
                  <v-btn
                    type="button"
                    color="error"
                    plain
                    @click="changeAction(1)"
                    :disabled="sending"
                  >
                    <v-icon left>mdi-close</v-icon> Cancelar
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn
                    type="submit"
                    :disabled="sending || invalid || selected == 0"
                    color="primary"
                  >
                    <v-icon left>mdi-content-save</v-icon> Guardar
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-form>
        </validation-observer>
      </v-card>
      <encabezado :elementos="encabezado" v-if="showAction(3)"/>
      <v-card v-if="showAction(3)">
        <v-card-text>
          <validation-observer ref="observer">
            <h3 class="font-weight-black ml-4 mb-10">
              Información de merma
              <span class="error--text">{{ model.idWarehouseOutput }}</span>
            </h3>
            <v-row class="ml-2">
              <v-col md="4">
                <v-text-field
                  prepend-icon="mdi-account"
                  v-model="model.humanResourceName"
                  label="Responsable"
                  required
                  disabled
                />
              </v-col>
              <v-col md="4">
                <v-text-field
                  prepend-icon="mdi-cube-outline"
                  v-model="model.quantityStocks"
                  label="Cantidad total"
                  required
                  disabled
                />
              </v-col>
              <v-col md="4">
                <v-text-field
                  prepend-icon="mdi-calendar"
                  v-model="model.registrationDateText"
                  label="Fecha de registro"
                  required
                  disabled
                />
              </v-col>
            </v-row>
            <v-row class="ml-2">
              <v-col>
                <p class="mt-5 font-italic">
                  <v-icon left>mdi-comment-outline</v-icon>
                  {{ model.comment }}
                </p>
              </v-col>
            </v-row>
            <v-divider class="mb-4 mt-2 ml-5 mr-5"></v-divider>

            <h3 class="font-weight-black ml-5">Productos</h3>

            <v-text-field
              v-model="searchStock"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
              class="mx-5 mb-3"
            ></v-text-field>
            <v-data-table
              :headers="headersStockOut"
              :items="model.stocks"
              :search="searchStock"
              :items-per-page="5"
              :footer-props="{
                'items-per-page-text': 'Elementos por página',
                'items-per-page-all-text': 'Todo',
              }"
              no-results-text="Sin resultados coincidentes con el búsqueda"
              loading-text="Cargando..."
              no-data-text="Sin resultados disponibles"
              dense
              fixed-header
              height="auto"
            >
              <template v-slot:[`item.product.fullName`]="{ item }">
                <small>{{ item.product.fullName }}</small>
              </template>
              <!-- <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon @click="checkHistory(item)">
                      <v-icon color="primary" v-bind="attrs" v-on="on">
                        mdi-history
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Visualizar historial del Stock</span>
                </v-tooltip>
              </template> -->
            </v-data-table>
            <v-divider class="mb-4 mt-2 ml-5 mr-5"></v-divider>

            <div class="d-flex justify-center">
              <v-col class="d-flex justify-space-around mb-10 mt-10">
                <v-row>
                  <v-col align="center" align-self="end">
                    <v-btn
                      type="button"
                      color="error"
                      @click="changeAction(1)"
                      :disabled="sending"
                      plain
                    >
                      <v-icon left>mdi-chevron-left</v-icon> Volver
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </div>
          </validation-observer>
        </v-card-text>
        <v-dialog
          v-model="dialogHistory"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="clearHistory()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title id="inicio"
                >Historial de movimientos del Stock:
                <b>{{ dataHistory.idStock }}</b></v-toolbar-title
              >
              <v-spacer></v-spacer>
              <!-- <v-toolbar-items>
            <v-btn dark text @click="dialogHistory = false"> Save </v-btn>
          </v-toolbar-items> -->
            </v-toolbar>
            <v-list three-line subheader>
              <v-subheader>Información del Stock</v-subheader>
              <v-row
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <v-col>
                  <v-list-item>
                    <v-list-item-content>
                      <div
                        style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        "
                      >
                        <v-icon>mdi-file-document</v-icon>
                      </div>
                      <div
                        style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        "
                      >
                        Información del Stock
                      </div>
                      <br />
                      <div
                        style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        "
                      >
                        <div>
                          <v-list-item-subtitle
                            >Fecha de registro:
                            <b>{{
                              dataHistory.registrationDate
                            }}</b></v-list-item-subtitle
                          >
                          <v-list-item-subtitle
                            >Producto:
                            <b>{{ dataHistory.p }}</b></v-list-item-subtitle
                          >
                          <v-list-item-subtitle
                            >Existencia:
                            <b>{{
                              dataHistory.quantity
                            }}</b></v-list-item-subtitle
                          >
                        </div>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
              <!-- <v-card-text>{{ dataHistory }}</v-card-text> -->
            </v-list>
            <v-divider></v-divider>
            <v-list three-line subheader>
              <v-subheader>Historial de Stock</v-subheader>
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <div style="width: 95%">
                  <v-row align="baseline" justify="center" class="pb-4">
                    <v-col>
                      <v-text-field
                        v-model="searchHistory"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <br />
                  <v-data-table
                    :headers="headersHistory"
                    :items="listHistory"
                    :search="searchHistory"
                    no-results-text="Sin resultados coincidentes con la búsqueda"
                    loading-text="Cargando..."
                    no-data-text="Sin resultados disponibles"
                    dense
                    hide-default-footer
                    disable-pagination
                    fixed-header
                    height="auto"
                  >
                    <template v-slot:[`item.typeHistoryDesc`]="{ item }">
                      <v-chip
                        :color="item.color"
                        style="width: 200px; justify-content: center"
                      >
                        {{ item.typeHistoryDesc }}
                      </v-chip>
                    </template>
                  </v-data-table>
                </div>
              </div>
            </v-list>
          </v-card>
        </v-dialog>
      </v-card>
      <v-dialog v-model="dialog" width="600">
        <v-card>
          <v-card-text>
            <div class="col-md-12 text-center">
              <DateByRangeComponent
                ref="DateByRangeComponent"
                :typeCalendar="3"
                v-on:dateChange="dateChange"
              />
            </div>
            <v-row>
              <v-col class="text-center">
                <v-btn @click="dialog = false" color="error" plain>
                  <v-icon left> mdi-chevron-left </v-icon> volver
                </v-btn>
              </v-col>
              <v-col class="text-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="downloadStartingOrder()"
                      color="error"
                      v-bind="attrs"
                      v-on="on"
                      :disabled="dateSelected.startDate == ''"
                    >
                      <v-icon left> mdi-file-pdf-box </v-icon> Descargar Reporte
                    </v-btn>
                  </template>
                  <span>Descargar reporte de Salida</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "@/components/Sidebar";
import AutoLogout from "@/components/AutoLogout.vue";
import Loader from "@/components/Loader.vue";
import DateByRangeComponent from "@/components/Calendars.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { UtilFront } from "@/core/";

import {
  StockRequest,
  ProductsRequest,
  ReportPDFRequest,
} from "@/core/request";
import BranchOfficesList from "../../components/BranchOfficesList.vue";

export default {
  name: "Merma",
  components: {
    Loader,
    Sidebar,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    AutoLogout,
    BranchOfficesList,
    DateByRangeComponent,
  },
  data() {
    return {
      sending: false,
      dialog: false,
      dialogHistory: false,
      dataHistory: {},
      listHistory: [],
      searchHistory: "",
      headersHistory: [
        { text: "ID Historial", value: "idStockHistory" },
        { text: "Fecha de registro", value: "registrationDateHistory" },
        { text: "Destino", value: "locationKey" },
        { text: "Descripción", value: "typeHistoryDesc" },
        { text: "Responsable", value: "nameHumanResource" },
      ],
      menu: false,
      index: -1,
      action: 1,
      list: [],
      model: {},
      service: StockRequest,
      search: "",
      headers: [
        { text: "Id Salida", value: "idWarehouseOutput", align: "center" },
        { text: "Fecha de registro", value: "registrationDateText", align: "center" },
        { text: "Nombre del responsable", value: "humanResourceName", align: "center" },
        { text: "Cantidad de productos", value: "quantityStocks", align: "center" },
        { text: "Acciones", value: "actions", sortable: false, align: "center"},
      ],
      encabezado: {
        icono: "mdi-exit-to-app",
        texto: "Mermas | Farmacia",
      },
      headersStock: [
        { text: "Id Stock", value: "idStock" },
        { text: "Clave", value: "product.product_key" },
        { text: "Producto", value: "product.fullName", width: "35%" },
        { text: "Existencia", value: "quantity" },
        {
          text: "Cantidad",
          value: "quantityOutput",
          sortable: false,
          align: "center",
        },
        { text: "Caducidad", value: "expirationDateText" },
        { text: "Lote", value: "lot" },
        {
          text: "Seleccionar",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      searchStock: "",
      types: [
        { text: "Merma", value: 1 },
        { text: "Salida", value: 2 },
      ],
      all: false,
      selected: 0,
      products: [],
      status: ["Bueno", "Regular", "Malo"],
      stocks: [],
      supplier: "",
      headersStockOut: [
        { text: "Id Stock", value: "stock.idStock" },
        { text: "Clave", value: "stock.product.product_key" },
        { text: "Producto", value: "stock.product.fullName", width: "35%" },
        { text: "Existencia restante", value: "stock.quantity" },
        {
          text: "Cantidad",
          value: "quantity",
          sortable: false,
          align: "center",
        },
        { text: "Caducidad", value: "stock.expirationDateText" },
        { text: "Lote", value: "stock.lot" },
        //{ text: "Acciones", value: "actions", sortable: false },
      ],
      idBranchOfficeSelected: null,
      dialog: false,
      dateSelected: { startDate: "", endDate: "" },
      cols: "col-md-3 col-xl-3 col-sm-12",
    };
  },
  mounted() {
    this.listAll();
    this.listProducts();
  },
  methods: {
           downloadReportXLSX() {
     this.sending = true;

      ReportPDFRequest.exportDecrease({
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
            })
        .then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel",
            })
          );

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Consulta_Merma.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.sending = false;
        });
    },
    DownloadPDF() {
      this.sending = true;
      let data = {
        InitialDate: InitialDate.InitialDate,
        EndDate: EndDate.EndDate,
      };
      ReportPDFRequest.downloadDecrease(data);
      this.sending = false;

      this.dialog = false;
    },
    catchError: (e, x) => {
      UtilFront.errorhttp(e);
    },
    showAction(action) {
      return this.action == action;
    },
    changeAction(action) {
      if (action == 1) {
        this.$refs.observer.reset();
        this.model = {};
        this.stocks = [];
        this.supplier = "";
        this.action = action;
        this.all = false;
        this.selected = 0;
        this.searchStock = ''
      } else {
        this.listAllStock();
        this.action = action;
      }
    },
    doAction() {
      switch (this.action) {
        case 2:
          this.add();
          break;
        case 3:
          this.update();
          break;
        default:
          break;
      }
    },
    listAll() {
      this.sending = true;
      let params = {
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
      };
      this.service
        .listAllWarehouseOutputByBranchOffice(params)
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.list = data;
          } else {
            this.list = [];
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
    },
    add() {
      if(!this.sending){
        this.sending = true;
      let stocksOutput = this.stocks.filter((it) => {
          return it.unsubscribe == true;
        }).map((it) => {
          return { idStock: it.idStock, quantity: it.quantityOutput };
        });

      let data = {
        type: 1, //Merma
        idBranchOffice: this.$utilFront.getIdBranchOffice(),
        idHumanResource: this.$utilFront.getIdHumanResource(),
        stocks: stocksOutput,
      };
      let params = Object.assign(this.model, data);

      this.service.addOutput(params).then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.$utilFront.notifications(
              "Se ha registrado correctamente.",
              "SUCCESS"
            );
            this.listAll();
            this.changeAction(1);
          } else {
            message = message || "Ocurrió un error durante el registro.";
            this.$utilFront.notifications(message, "ERROR");
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
      }
    },
    listAllStock() {
      this.stocks = [];
      this.sending = true;
      let params = {
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
        statusStock: [1],
      };
      this.service
        .listAllByBranchOffice(params)
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.stocks = data;
            this.stocks.map((product) => {
              product.quantityOutput = 0;
            })
          } else {
            this.stocks = [];
            this.$utilFront.notifications(
              "Sin resultados disponibles.",
              "WARNING"
            );
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
    },
    selectedAll() {
      if (this.$utilFront.nonEmptyList(this.stocks)) {
        this.stocks = this.stocks.map((it) => {
          it.unsubscribe = this.all;
          return it;
        });
        this.updateAll();
      }
    },
    updateAll() {
      this.all = false;
      let filtered = this.stocks.filter(function (it) {
        it.quantityOutput = it.unsubscribe ? it.quantityOutput : 0; 
        return it.unsubscribe == true;
      });
      this.selected = filtered.length;
      this.all = filtered.length == this.stocks.length && this.stocks.length > 0;
    },
    listProducts() {
      this.products = [];
      ProductsRequest.listAllProducts()
        .then((res) => {
          let { data, response, message } = res.data;
          if (this.$utilFront.nonEmptyList(data)) {
            this.products = data.map((it) => {
              let product = {
                idProduct: it.idProduct,
                fullName: it.name + " " + it.text,
                product_key: it.product_key,
              };
              return {
                text: `${it.product_key} | ${it.name} | ${it.text}`,
                value: product,
              };
            });
          }
        })
        .catch(this.catchError)
        .finally(() => {});
    },

    addList() {
      let stock = Object.assign(this.model, {});
      stock.expiration = moment(stock.expiration).endOf("day").toDate();
      this.stocks.unshift(stock);
      this.model = {};
      this.$refs.observer.reset();
    },
    outRangeStocks() {
      // if(this.$utilFront.nonEmptyList(this.stocks)){
      //   let outRangeStocks = this.stocks.filter((it)=>{
      //     return it.unsubscribe == true && it.quantityOutput > it.quantity && it.quantityOutput < 0;
      //   });
      //   this.outRange = this.$utilFront.nonEmptyList(outRangeStocks);
      // }
      // this.outRange = false;
    },
    get(item, index) {
      this.sending = true;
      let params = { idWarehouseOutput: item.idWarehouseOutput };
      this.service
        .getWarehouseOutput(params)
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.model = data;
            this.changeAction(3);
          } else {
            this.$utilFront.notifications(
              "Sin resultados disponibles.",
              "WARNING"
            );
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
    },
    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.listAll();
    },
    dateChange(dates) {
      this.dateSelected = dates;
    },
    downloadStartingOrder() {
      this.sending = true;
      const fileName = `Orden_de_salida_${moment(
        new Date(this.dateSelected.startDate)
      ).format("YYYY-MM-DD")} - ${moment(
        new Date(this.dateSelected.endDate)
      ).format("YYYY-MM-DD")}`;
      const data = {
        fileName: fileName,
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
        startDate: this.dateSelected.startDate,
        endDate: this.dateSelected.endDate,
      };
      ReportPDFRequest.downloadStartingOrder(data)
        .then((res) => {
          if (res.status == 200 && res.data.type != "application/json") {
            this.$utilFront.openPDF(res.data);
          } else {
            this.$utilFront.displayErrorPdf(res.data);
          }
        })
        .finally(() => {
          this.$refs.DateByRangeComponent.modalDateRangeClean();
          this.sending = false;
        });
      this.dialog = false;
    },
    clearHistory() {
      this.dialogHistory = false;
      this.dataHistory = {};
    },
    checkHistory(item) {
      this.loader = true;
      this.dataHistory = item.stock;
      let postData = {
        idStock: item.stock.idStock,
      };
      this.service
        .stockHistory(postData)
        .then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.listHistory = res.data.data.map((obj) => {
              let typeHistoryDesc;
              let color;
              switch (obj.typeHistory) {
                case 1:
                  typeHistoryDesc = "Entrada de Producto";
                  color = "primary";
                  break;
                case 2:
                  typeHistoryDesc = "Baja de Producto";
                  color = "warning";
                  break;
                case 3:
                  typeHistoryDesc = "Dispensación de Producto";
                  color = "info";
                  break;
              }
              return {
                idStockHistory: obj.idStockHistory,
                humanResource: obj.humanResource,
                nameHumanResource: obj.humanResource.person.fullName,
                registrationDateHistory: moment(obj.registrationDate).format(
                  UtilFront.FORMAT_DATE_TIME
                ),
                locationKey: obj.locationKey,
                typeHistoryDesc: typeHistoryDesc,
                type: obj.typeHistory,
                color: color,
              };
            });
          } else if (code == 401) {
            this.unauthorized();
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.dataHistory.registrationDate =
            typeof item.registrationDate === "number"
              ? moment(item.registrationDate).format(UtilFront.FORMAT_DATE_TIME)
              : item.registrationDate;
          this.dataHistory.p = this.dataHistory.product.name;
          this.loader = false;
          this.dialogHistory = true;
        });
    },
  },
};
</script>
